import { render } from "./Modal.vue?vue&type=template&id=505c095c"
import script from "./Modal.vue?vue&type=script&lang=js"
export * from "./Modal.vue?vue&type=script&lang=js"

import "./Modal.vue?vue&type=style&index=0&id=505c095c&lang=css"

import exportComponent from "C:\\Users\\Librom\\Projects\\librodex-v2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__